import React from 'react';

import { FormattedMessage } from 'react-intl';

import { MediaClientConfig } from '@atlaskit/media-core';

import { AttachmentEntryItem } from 'src/components/activity/types';
import Loading from 'src/components/loading';
import {
  Attachment,
  MediaAttachmentFilmstrip,
} from 'src/components/media-attachment-filmstrip';

import { messages } from './pull-request-activity-events.i18n';

type PullRequestAttachmentTitleProps = {
  numberOfAttachments: number;
};

export const PullRequestAttachmentTitle = ({
  numberOfAttachments,
}: PullRequestAttachmentTitleProps): JSX.Element => {
  return (
    <FormattedMessage
      {...messages.attachmentAddedMessage}
      values={{ numOfAttachments: numberOfAttachments }}
    />
  );
};

type PullRequestAttachmentBodyProps = {
  isLoading: boolean;
  mediaClientConfig?: MediaClientConfig;
  attachments: AttachmentEntryItem[];
  collectionName: string;
};

export const PullRequestAttachmentBody = (
  props: PullRequestAttachmentBodyProps
): JSX.Element | null => {
  if (props.isLoading) {
    return <Loading size="small" />;
  } else if (props.mediaClientConfig) {
    return (
      <MediaAttachmentFilmstrip
        attachments={props.attachments as Attachment[]}
        collectionName={props.collectionName}
        mediaClientConfig={props.mediaClientConfig}
      />
    );
  }
  return null;
};
